import type { ApplicationItem } from "@/types/Application/application";

export const profileFields = [
  { label: "Nombor Telefon", key: "phoneNumber" },
  { label: "Nombor MyKad atau pasport", key: "identityNo" },
  { label: "Jantina", key: "gender" },
  { label: "Umur", key: "age" },
  { label: "Alamat", key: "address", colSpan: 2 },
  { label: "Landmark Rumah", key: "houseBenchmark", colSpan: 2 },
] satisfies ReadonlyArray<{
  label: string;
  key: keyof ApplicationItem;
  colSpan?: number;
}>;

export const residentFields = [
  ["Status kediaman", "houseStatus"],
  ["Tempoh menetap", "yearsOfResidence"],
  ["Pekerjaan", "occupationType"],
  ["Kekerapan Penggunaan Feri", "frequencyFerryUse"],
  ["Bil. Motosikal", "totalMotorcycle"],
  ["Bil. Kereta", "totalCar"],
  ["Bil. Kenderaan Elektrik", "totalElectricVehicle"],
  ["Rujukan", "registrationRemark"],
] satisfies ReadonlyArray<
  readonly [string, keyof ApplicationItem]
>;